import React from 'react';

const RequisitesAdd = () => {
    return (
        <div>
            
        </div>
    );
};

export default RequisitesAdd;